import Impersonate from './container';

export default Impersonate;



// WEBPACK FOOTER //
// ./src/routes/Impersonate/index.js